/**
 * Accordion component
 * @returns <Accordion />
*/
import AccordionItem from "./AccordionItem"

const Accordion = ({ items, type }) => {
    return (
        <div className={`accordion ${type === "filters" ? "filters" : ""}`}>
            <div className="wrapper">
                {items.map((item, i) => {
                    {/* console.log(items) */ }
                    return (
                        <AccordionItem key={i} item={item} type={type} hasHtml={item.hasHtml} />
                    )
                })}
            </div>
        </div>
    )
}

export default Accordion